export default "__VITE_ASSET__86e41ff9__"